import React from 'react'
import { connect } from 'react-redux'
import { resetShowDestalleCuposADescargar, editarProyeccionExportador } from '../../actions/listados'
import { IconButton, Tooltip } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { COLORES } from '../../../../config/colores'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_ESTIMACION_STOCK } from '../../../../config/forms'
import moment from 'moment'
import { cerealesColor } from '../../../../config/cereales'

function DetalleCuposPorFecha (props) {
  const { asignados, proyectados, fecha, cumplimiento, exportador, descargaPotencial, netoPromedio, cereal } = props

  const handleClose = () => {
    props.resetShowDestalleCuposADescargar()
  }

  const procesarCupos = (data, fecha, cereal, cerealKey, fechaKey, cantidadKey) => {
    let cuposResultado = []
    const cuposFiltrados = data && data.filter(c => c[fechaKey] === fecha)

    if (!cuposFiltrados || cuposFiltrados.length === 0) {
      return []
    }

    if (cereal === 'TODOS') {
      cuposResultado = cuposFiltrados
    } else {
      cuposResultado = cuposFiltrados.filter(c => c[cerealKey] && c[cerealKey].trim() === cereal)
    }
    return cuposResultado
  }

  const detalleCupos = (titulo) => {
    const fechaDetalle = moment(fecha, 'DD/MM/YYYY').format('YYYY-MM-DD')
    const hoy = moment(new Date()).format('YYYY-MM-DD')
    let dataCupos
    let fechaKey
    let cantidadKey
    let cerealKey

    if (titulo === 'Cupos a descargar') {
      if (fecha === hoy) {
        console.log('es hoy ')
        console.log('de donde puedo sacar daots ', props.cuposVigentes

        )
        dataCupos = props.cuposVigentes
        fechaKey = 'fechaDeEmision'
        cerealKey = 'claveCereal'
        cantidadKey = 'cantidadAsignada'
      } else {
        dataCupos = props.cuposVigentes
        fechaKey = 'fechaDeEmision'
        cerealKey = 'claveCereal'
        cantidadKey = 'cantidadAsignada'
      }
    } else {
      dataCupos = props.cuposProyectados
      fechaKey = 'fecha'
      cerealKey = 'cereal'
      cantidadKey = 'cantidadAsignada'
    }

    if (!dataCupos) {
      return []
    }

    const cuposFinales = procesarCupos(
      dataCupos,
      fechaDetalle,
      cereal,
      cerealKey,
      fechaKey,
      cantidadKey
    )

    return (
      cuposFinales.map((cupo) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} key={`${cupo[cerealKey]}-${cupo.exportador}`}>
            <Tooltip title={`${cupo[cerealKey].trim()}`}>
              <div
                className={`ship-dot`}
                style={{ width: '10px', height: '10px', backgroundColor: cerealesColor[(cupo[cerealKey]).trim()] }}
              />
            </Tooltip>
            <p
              style={{
                fontSize: '12px',
                margin: '0 5px',
                padding: 0,
                textAlign: 'left'
              }}
              // key={cupo.exportador}
            >
              {cupo[cantidadKey]} - {cupo.exportador}
            </p>
          </div>
        )
      })
    )
  }

  const renderDato = (titulo, valor) => {
    let c = cumplimiento
    const netoPromedioTn = netoPromedio / 1000
    const cuposADescargar = (asignados + proyectados) || 0

    if (cereal === 'TODOS') {
      const descargaEnCamiones = descargaPotencial / netoPromedioTn
      if (cuposADescargar > 0) {
        c = Math.round((descargaEnCamiones / cuposADescargar) * 100)
      }
    }

    const parsedValue = titulo === 'Cumplimiento' ? `${c} %` : valor

    return (
      <div
        style={{
          borderRadius: '8px',
          border: '2px solid',
          bordercolor: 'white',
          padding: '8px',
          margin: '8px',
          display: 'flex',
          width: '22%',
          flexDirection: 'column',
          color: 'white'
        }}
        key={titulo}
      >
        <h6 style={{ margin: 0, padding: 0 }}>{titulo}</h6>
        <h1
          style={{
            fontWeight: 'bold',
            color: 'white',
            margin: '8px 0 0 0',
            fontSize: '2rem',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {parsedValue}
        </h1>
        { (titulo === 'Cupos a descargar' || titulo === 'Proyectados') && !exportador &&
          <div style={{ marginTop: '8px' }}>
            {detalleCupos(titulo)}
          </div>
        }

      </div>
    )
  }

  return (
    <div style={{ marginTop: '2%' }}>
      {fecha && cumplimiento &&
        <div style={{
          backgroundColor: COLORES.grey.dark,
          color: 'white',
          border: '2px solid',
          borderRadius: '8px'
        }}
        >
          {exportador && <span style={{ textAlign: 'left', fontWeight: 'bold' }}>{exportador}</span>}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            { renderDato('Fecha', fecha) }
            { renderDato('Cupos a descargar', asignados) }
            { renderDato('Proyectados', proyectados) }
            { renderDato('Cumplimiento', cumplimiento) }

            <IconButton onClick={handleClose}>
              <CloseIcon style={{ color: 'white' }} />
            </IconButton>
          </div>
        </div>
      }
    </div>
  )
}

const selector = formValueSelector(FORM_ESTIMACION_STOCK)

const mapStateToProps = (state) => ({
  asignados: state.stock.cuposAsignadosShow,
  proyectados: state.stock.cuposProyectadosShow,
  fecha: state.stock.fechaProyeccionShow,
  cumplimiento: state.stock.cumplimientoShow,
  descargaPotencial: state.stock.descargaPotencialShow,
  netoPromedio: state.camionesIngreso.promedioPesoCamion,
  cereal: state.stock.cerealEstimacionStock,
  exportador: selector(state, 'exportadorProyeccion'),
  cuposVigentes: state.cupos.cuposVigentes,
  cuposProyectados: state.stock.cuposProyectados
})

const mapActionsToProps = {
  editarProyeccionExportador,
  resetShowDestalleCuposADescargar
}

const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  destroyOnUnmount: false
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(DetalleCuposPorFecha))
